var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['status', { orange: _vm.orange, green: _vm.green, purple: _vm.purple, brown: _vm.brown, blue: _vm.blue }]},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }